
<template>
  <div id="content"  v-show="!loading">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a v-if="!entity.enabled && editable"
             class="btn btn_action btn_grey btn_enable"
             :title="'Aktivovat' | translate"
             @click.prevent.stop="updateActive(true)"
             v-translate>Aktivovat</a>
          <a v-if="entity.enabled  && editable"
             class="btn btn_action btn_grey btn_disable"
             :title="'Deaktivovat' | translate"
             @click.prevent.stop="updateActive(false)"
             v-translate>Deaktivovat</a>
          <a v-if="$_deleteActionAllowed && !entity.id_remote"
             class="btn btn_action btn_delete"
             :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity"
             v-translate>Smazat</a>
        </p>
        <h1 v-translate>Editace blokovaného obsahu</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :disabled="true"
                    :options="operatorOptions"
                    :required="true"
                >
                </operator-select>
              </div>
            </div>
          </section>
            <blackout-content-basic-form
                :entity="entity"
                :is-editable="editable"
                ref="streamprofileformref"
            ></blackout-content-basic-form>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     v-if="this.$_updateActionAllowed && ((entity.id_remote && !$_loggedUser_selectedOperatorId) || (!entity.id_remote))"
                     :class="['btn']"
                     @click.prevent.stop="submitForm()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import blackoutContents from "./mixins/blackoutContents";
import detailActions from "../../../components/mixins/detail-actions"
import BlackoutContentBasicForm from "./forms/BlackoutContentBasicForm.vue";

export default {
  name: "BlackoutContentDetail",
  components: {BlackoutContentBasicForm},
  mixins: [detailActions, blackoutContents],
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      entityName: "blackout_content",
    }
  },
  created(BlackoutContentService, OperatorService) {
    this.entityService = BlackoutContentService
    this.operatorService = OperatorService
    this.getOperators(true);
    this.createdInit().then(()=>{
      if(this.$_loggedUser_selectedOperatorId){
        this.entity.id_operator = this.$_loggedUser_selectedOperatorId;
      }
    })
  },
  computed: {
    editable() {
      return this.$_updateActionAllowed && !this.entity.id_remote;
    },
    operatorIdComputed: {
      get() {
        return this.entity.id_operator == null ? '0' : this.entity.id_operator;
      },
      set(newValue) {
        return this.entity.id_operator = newValue
      }
    }
  },
  methods: {
    updateActive(newValue){
      this.entityService.updateEntity(this.entity.id, {enabled: newValue, 'updateGlobalOnlyEnabled': true})
          .then(() => {
            this.emptyMessage()
            this.setSuccessMessage()
            this.entity.enabled = newValue
          })
          .catch(function (error) {
            this.setErrorMessage(this._processDetailErrorMessage(error))
          }.bind(this))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/blackoutContents/BlackoutContentDetail.vue